module.exports = __webpack_public_path__ + "static/flandal_steelskin-symbol-DND3_FnP-a7632c16a2cb11bc497b5dc16aab0ec6.webp";